const people = [
  {
    name: "Gregorium",
    planet: "MARS",
    address: "0x976EA74026E726554dB657fA54763abd0C3a0aa9",
  },
  {
    name: "Joonas Köppä",
    planet: "EARTH",
    address: "0x5b7acF012bbf5c9F16eeaE4acb7D6DA0107c5bbB",
  },
  {
    name: "Edoardo Piroddi",
    planet: "EARTH",
    address: "0xD4830F96d9Ed6d54E14b5FbC51538Caa14ca55b3",
  },
  {
    name: "Nasim Ali",
    planet: "EARTH",
    address: "0x77eEA3df32A7Db871AA196854be1760e7B1B121A",
  },
  {
    name: "Jing Tian",
    planet: "EARTH",
    address: "0x3695594CE9323Ef44Bea62667194CAB869A50315",
  },
  {
    name: "Natalia Ruiz",
    planet: "EARTH",
    address: "0x20853C928c4b0C006fC49FA95197f67CBD4c1d78",
  },
];

export default people;
